<script>
	import { fly } from 'svelte/transition';

	import CategorySummary from './CategorySummary.svelte';
	

    export let categories;
    export let flyIn;
    export let flyOut;

    export let categorySelected = null;

    function onCategorySelected (category) {
        categorySelected = category;
        window.location.href = '/#/?section=' + category.name;
    }
	
</script>


<div class="categories-container" in:fly="{flyIn}" out:fly="{flyOut}">
    {#each categories as category}
        <CategorySummary {category} on:click={() => onCategorySelected(category)} on:keypress={() => onCategorySelected(category)}/>
    {/each}
</div>

<style>
    .categories-container {
        margin-top: 15px;
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}
</style>